import { render, staticRenderFns } from "./ManualStatsUpdate.vue?vue&type=template&id=40b4cbfd"
import script from "./ManualStatsUpdate.vue?vue&type=script&lang=js"
export * from "./ManualStatsUpdate.vue?vue&type=script&lang=js"
import style0 from "./ManualStatsUpdate.vue?vue&type=style&index=0&id=40b4cbfd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports